import { IOnInit } from "angular";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import { Machine } from "../../../machines/shared/models/machine";
import { MachineConfiguration } from "../../../machines/shared/models/machineConfiguration";
import { Record } from "../../../records/server/crud";
import { IRowCommandEventArgs } from "../../../records/grids/controller";
import {
  GridConfiguration,
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../../records/views/recordGridView";
import { vsObjectName as mealLogObjectName } from "../../configs/mealLog";
import {
  CsvColumnConfig,
  CsvConfig,
  CsvWriter,
  vsName as CsvWriterName,
} from "../../../records/csv/csvWriter";

export class MealLogEntryListController implements IOnInit {
  static $inject = [
    ServerUtilityName,
    RecordGridViewServiceName,
    CsvWriterName,
  ];

  private readonly mealLogGridConfiguration: GridConfiguration;

  constructor(
    private readonly serverUtility: ServerUtility,
    recordGridViewService: RecordGridViewService,
    private readonly csvWriter: CsvWriter
  ) {
    this.mealLogGridConfiguration =
      recordGridViewService.getGridConfiguration(mealLogObjectName)!;
  }

  private machine!: Machine<MachineConfiguration>;

  pageIndex: number = 1;
  pageSize: number = 50;
  totalCount: number = 0;
  currentItems: any[] = [];

  $onInit() {
    this.fetchPage();
  }

  downloadCsv() {
    this.serverUtility
      .fetchAll({
        url: this.mealLogGridConfiguration.gridDataSource!.url,
        query: this.getBaseQuery(),
      })
      .then((r) => {
        const csvConfig: CsvConfig = {
          columns: (this.mealLogGridConfiguration.columns ?? []).map((c) => {
            return <CsvColumnConfig>{
              field: c.field,
              format: c.format,
              header: c.headerName,
            };
          }),
          includeHeaders: true,
        };
        const csv = this.csvWriter.getCsv(csvConfig, r);
        this.csvWriter.saveFile({
          content: csv,
          filename: `Machine ${this.machine.SerialNumber} MEAL Log.csv`,
        });
      });
  }

  private getBaseQuery() {
    return {
      MachineId: this.machine.Id,
      OrderBy: "-OpenedDate",
    };
  }

  fetchPage() {
    this.serverUtility
      .query({
        url: "/api/machines/mealLog/machineView",
        query: {
          ...this.getBaseQuery(),
          Skip: (this.pageIndex - 1) * this.pageSize,
          Take: this.pageSize,
        },
      })
      .then((queryResult) => {
        this.currentItems = this.buildItems(queryResult.Results);
        this.totalCount = queryResult.Total;
      });
  }

  afterDelete(args: IRowCommandEventArgs<Record>) {
    const itemIndex = this.currentItems.findIndex((i) => i.Id == args.data.Id);
    if (itemIndex > -1) {
      this.currentItems.splice(itemIndex, 1);
    }
  }

  //make the items match the shape that the entryDetail component expects
  private buildItems(items: any[]) {
    return items.map((i) => {
      return {
        ...i,
        MealLogReason: {
          Id: i.MealLogReasonId,
          Name: i.MealLogReasonName,
        },
        CreatedBy: {
          Id: i.CreatedById,
          DisplayName: i.CreatedByDisplayName,
        },
        info: {
          SerialNumber: i.SerialNumber,
        },
      };
    });
  }
}
